import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const AdminContainer = styled.div({
  display: 'flex',
  flex: 1,
  background: '#FFF',
  border: `solid 1px ${v.borderGray}`,
  borderRadius: '2px',
  margin: '1rem',
  padding: '1rem',
  flexDirection: 'column',

  'div.adminHeader': {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    paddingBottom: '10px',
    marginBottom: '10px',
    borderBottom: `dashed 2px ${v.borderDashGray}`,

    'div.headerTitle': {
      fontSize: '2rem',
      fontWeight: 'bold'
    }
  },
})

export const MenuContainer = styled.div({
  display: 'flex',
  flex: 1,
  // flexDirection: 'column',
})

export const AdminMenuButton = styled.div({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  border: `solid 1px ${v.borderGray}`,
  borderRadius: '5px',
  height: '120px',
  width: '150px',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '10px',

  'div.title': {
    fontWeight: 'bold',
    marginTop: '12px',
    fontSize: '1.2rem',
  },

  '&:hover': {
    border: `solid 1px ${v.ezMainColor}`,

    svg: {
      color: v.ezMainColor
    },

    'div.title': {
      color: v.ezMainColor
    },
  }
})